import React from "react"

import { useEffect, useState } from "react"
import { Switch } from "@headlessui/react"

export default function InputSwitch({ name, value, onChange }) {
  const [enabled, setEnabled] = useState(value)

  useEffect(() => {
    onChange && onChange(enabled)
  }, [enabled])

  return (
    <div className="mt-2">
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className={`${enabled ? "bg-purple-900" : "bg-purple-300"}
      relative inline-flex flex-shrink-0 h-[28px] w-[52px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${enabled ? "translate-x-6" : "translate-x-0"}
        pointer-events-none inline-block h-[24px] w-[24px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
        />
      </Switch>
    </div>
  )
}
